// Auth services
export const AUTH_API_PATH = 'auth';
// Get user data
export const FETH_USER = '/api/v1/users';
export const SELLERS_URL = '/api/v1/sellers';
